import { render } from "./LegalDocumentView.vue?vue&type=template&id=ec5abbd6&scoped=true"
import script from "./LegalDocumentView.vue?vue&type=script&lang=js"
export * from "./LegalDocumentView.vue?vue&type=script&lang=js"

import "./LegalDocumentView.vue?vue&type=style&index=0&id=ec5abbd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5abbd6"]])

export default __exports__